import { ResourceBase, ResourceType } from '@integration-frontends/integration/core/model';

export interface Tag extends ResourceBase {
  type: ResourceType.TAG;
  autoGenerated: boolean;
}
